<template>
  <div class="like_module">
    <!-- 讲解评价 -->
    <div class="comment flex-row flex-center">
      <div
        class="like flex-center"
        :class="{ comment_active: hasComment === 1 }"
        @click="commentQuestion('like')"
      >
        <img
          :src="
            hasComment === 1
              ? 'https://img.yzcdn.cn/upload_files/2020/12/07/Fu_ZDxaj_DtElqdtwNEGi1V4Uj3k.png'
              : 'https://img01.yzcdn.cn/upload_files/2021/02/22/Fi63HO00Zuo5c7pQG6VAK3d22XKG.png'
          "
         
        />
        讲解有帮助
      </div>
      <div
        class="nolike flex-center"
        :class="{ comment_active: hasComment === 0 }"
        @click="commentQuestion('shownolike')"
      >
        <img
          :src="
            hasComment === 0
              ? 'https://img.yzcdn.cn/upload_files/2020/12/07/FkDRqs4rqNQYdwcjcXmLIGIKQwua.png'
              : 'https://img01.yzcdn.cn/upload_files/2021/02/22/Fs_PUFv5zUn6n1rUcuOiVDC-2Pz9.png'
          "
         
        />
        讲解无帮助
      </div>
    </div>
    <!-- 不喜欢弹窗 -->
    <VanPopup
      v-model="noLikeShow"
      class="like_module_noLike"
      :overlay-style="{ zIndex: 9999 }"
      round
      position="bottom"
      get-container="body"
    >
      <div class="noLike_pop">
        <div class="selectItems flex-row flex-jc-bt">
          <div
            v-for="(item, index) in noLikeItems"
            :key="index"
            class="selectItem flex-center"
            :class="{ noLikeItems_active: selectItem === item.value }"
            @click="selectItem = item.value"
          >
            {{ item.key }}
          </div>
        </div>
        <div v-if="selectItem === 'other'" class="other">
          <textarea
            v-model="commentValue"
            maxlength="50"
            placeholder="请输入您的评价(必填)，50字以内"
          ></textarea>
        </div>
        <div class="submit flex-center" @click="commentQuestion('nolike')">提交</div>
        <div class="cancel flex-center" @click="noLikeShow = false">取消</div>
      </div>
    </VanPopup>
  </div>
</template>
<script>
import { basicbookExplainEnjoy } from '@/api/explain'
import { mapState } from 'vuex'
import { Toast } from 'vant'
import { noLikeItems } from './data'

export default {
  props: {
    explain: {
      type: Object,
      default: () => ({})
    },
    checkSv: {
      type: Function,
      default: () => () => {}
    }
  },
  data() {
    return {
      noLikeItems,
      noLikeShow: false,
      selectItem: null,
      commentValue: ''
    }
  },
  computed: {
    ...mapState('answerExplain', ['explains', 'hasEnjoyList', 'hasViewExplainRight']),
    hasComment() {
      const hasEnjoy = this.hasEnjoyList.find((i) => i.explainId === (this.explain || {}).id)
      return this.explain && (hasEnjoy || {}).enjoy
    }
  },
  methods: {
    commentQuestion(type) {
      const selectExplain = this.explain

      this.checkSv(() => {
        const questionId = this.$route.query.questionId
        if ([0, 1].includes(this.hasComment)) {
          return
        }
        switch (type) {
          // 展示不喜欢
          case 'shownolike': {
            this.noLikeShow = true
            break
          }
          // 不喜欢
          case 'nolike': {
            if (this.selectItem === 'other' && !this.commentValue) {
              Toast({
                className: 'explain_nolike_Toast',
                message: '请输入原因'
              })
              return
            }
            basicbookExplainEnjoy({
              ...selectExplain,
              explainId: selectExplain.id,
              questionId,
              enjoy: 0,
              enjoyType: this.selectItem,
              reason: this.selectItem === 'other' ? this.commentValue : ''
            }).then((res) => {
              if (res.data.status === 200) {
                Toast('评价成功')
                this.noLikeShow = false
                this.$store.dispatch('answerExplain/getEnjoyList', {
                  questionId: this.$route.query.questionId
                })
              }
            })
            break
          }
          // 喜欢
          case 'like': {
            basicbookExplainEnjoy({
              ...selectExplain,
              explainId: selectExplain.id,
              questionId,
              enjoy: 1
            }).then((res) => {
              if (res.data.status === 200) {
                Toast('提交成功')
                this.$store.dispatch('answerExplain/getEnjoyList', {
                  questionId: this.$route.query.questionId
                })
                this.$store.commit('answerExplain/setExplainNum', {
                  explainId: selectExplain.id,
                  type: 'yct'
                })
              }
            })
            break
          }
          default:
            break
        }
      })
    }
  }
}
</script>
<style lang="scss">
.explain_nolike_Toast {
  z-index: 1000000 !important;
}
.like_module {
  .comment {
    height: 58px;
    font-size: 14px;
    color: #ff2638;
    border-radius: 0px 0px 6px 6px;
    img {
      width: 20px;
      display: inline-block;
      margin-right: 4px;
    }
    .like {
      width: 126px;
      height: 34px;
      background: rgba(255, 38, 56, 0.07);
      border-radius: 17px;
      margin-right: 17px;
    }
    .nolike {
      width: 126px;
      height: 34px;
      background: rgba(255, 38, 56, 0.07);
      border-radius: 17px;
    }
    .comment_active {
      background: #ff2638;
      color: #ffffff;
    }
  }
}
.like_module_noLike {
  z-index: 10000 !important;
  .noLike_pop {
    padding: 30px 16px;
    .selectItems {
      flex-wrap: wrap;
      .selectItem {
        width: 160px;
        height: 38px;
        background: #f9f9f9;
        border-radius: 19px;
        font-size: 16px;
        color: #333333;
        margin-bottom: 15px;
      }
      .noLikeItems_active {
        background: #fef4f4;
        border: 0.5px solid #fed8d5;
        color: #ff2638;
      }
    }
    .other {
      height: 138px;
      background: #fbfbfb;
      border-radius: 4px;
      padding: 10px;
      textarea {
        width: 100%;
        height: 100%;
        font-size: 16px;
        color: #333333;
        resize: none;
      }
      textarea::-webkit-input-placeholder {
        font-size: 16px;
        line-height: 22px;
        color: #999999;
      }
    }
    .submit {
      margin-top: 15px;
      height: 50px;
      background: #ff2638;
      border-radius: 123px;
      font-size: 16px;
      color: #ffffff;
    }
    .disabled {
    }
    .cancel {
      margin-top: 15px;
      height: 50px;
      border: 0.5px solid #d9d9d9;
      box-sizing: border-box;
      border-radius: 123px;
      font-size: 16px;
      color: #333333;
    }
  }
}
</style>
